import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './HrUploadFolder.css';

const HR_ROOT = process.env.REACT_APP_HR_START_PATH || '/hr';

function HrUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={HR_ROOT}
      sessionPrefix="hr_folder"
    />
  );
}

HrUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default HrUploadFolder;
